export default "__VITE_ASSET__tQkxfWhu__"